import script from "./WinBackViewV1.vue?vue&type=script&setup=true&lang=js"
export * from "./WinBackViewV1.vue?vue&type=script&setup=true&lang=js"

import "./WinBackViewV1.vue?vue&type=style&index=0&id=2ac2b0e6&lang=scss"

const __exports__ = script;

export default __exports__